import React, {Component} from 'react';

import { cf } from './cf';
import { ce } from './ce';
import { ic } from './ic';
import { bf } from './bf';
import { cp } from './cp';

import cView from './cView';

export default class cOrgList extends cView {
  //
  $id_stgs = { //  子で上書き
  };
  //
  $cd_stss = { // 親を上書き
    sld_cm30ss: {},
  };

  $clp_loads = () => [ // 親を上書き
    new Promise( _o_end1 => {
      global.c?.setState({
        sgcd_pagePntKeys: bf.p(global.c?.state.sgcd_pagePntKeys, _next => { // cmd30_key の初期化
          _next.cm30_key = '0'; // 全体共通
          _next.cm30c310 = '全社共通'; // 全体共通
        }),
      }, () => {
        _o_end1();
      });
    }),
    cp.$cp_hlr_cm30({
      mode: 'items',
      state: 'sld_cm30ss',
      cnd: bf.b([
        { // 全社運営者
          b_when: 
            bf.i(global.c?.state.sgc_pageRole, ['adm1', 'own2']),
          o_then: () => 
            bf.q('[cm30b11k]="{}"'.f(
              global.c?.state.sgcd_pagePntKeys.cm20_key
            )),
        },
        { // 一般利用者・部門運営者
          o_else: () => {
            return bf.q(`
              [_KEY] IN (
                SELECT 
                  [cm31b21k]::NUMERIC::INTEGER 
                FROM 
                  [t_cm31] 
                WHERE 
                  [cm31b31k]="{}" AND 
                  [cm31c410]="20" AND 
                  IFNULL([cm31cz10],"10")<>"0"
              )
            `.f(
              global.c?.state.sgcd_pagePntKeys.cm10_key
            ));
          },
        },
      ]),
    }),    
  ];
}
